<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    div.py-6.px-10
      .text-lg.font-semibold.text-center Not found
      .text-md.text-center No consultation found for this patient
    v-divider
    v-card-actions.px-6
      v-spacer
      v-btn.button-md(color="info500" depressed dark @click="onRedirect") {{ buttonText }} ({{ counter }})
</template>

<script>
import { isServerSide } from '@/utils'

export default {
  props: {
    open: {
      type: Boolean,
    }
  },
  data() {
    return {
      timer: null,
      counter: 6
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.updateTimer()
    }, 1000);
  },
  watch: {
    counter(value) {
      if (value === 0) {
        this.onRedirect()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    buttonText () {
      if (isServerSide()) return 'Redirect'

      return 'Back'
    }
  },
  methods: {
    closeDialog () {
      this.$emit('cancel')
      this.showDialog = false
    },
    updateTimer () {
      if (this.counter !== 0) this.counter--
    },
    onRedirect () {
      // Redirect to registration if coming from server side
      if (isServerSide()) {
        return this.$router.push('/admin/clinic/registration')
      }
      // Else to back
      this.$router.back()
    }
  },
}
</script>